function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "info");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.5,3A31.5,31.5,0,1,0,66,34.5,31.53,31.53,0,0,0,34.5,3Zm-1,56.68q-5.18,0-5.18-4.87t5.18-4.88q4.88,0,4.87,4.88T33.53,59.68Zm4.72-43.42c-.1,1-.28,2.5-.56,4.5s-.66,4.8-1.16,8.4-1.13,8.52-1.88,14.77H32.4q-.9-9.37-1.5-14.77t-1-8.4c-.25-2-.43-3.5-.53-4.5s-.15-2-.15-3.08q0-5.47,4.58-5.47t4.57,5.47C38.4,14.23,38.35,15.26,38.25,16.26Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.83,7.71q-4.57,0-4.58,5.47c0,1.05.05,2.08.15,3.08s.28,2.5.53,4.5.57,4.8,1,8.4.9,8.52,1.5,14.77h2.25q1.13-9.37,1.88-14.77t1.16-8.4c.28-2,.46-3.5.56-4.5s.15-2,.15-3.08Q38.4,7.7,33.83,7.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.53,49.93q-5.18,0-5.18,4.88t5.18,4.87q4.88,0,4.87-4.87T33.53,49.93Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5,0A34.5,34.5,0,1,0,69,34.5,34.54,34.54,0,0,0,34.5,0Zm0,66A31.5,31.5,0,1,1,66,34.5,31.53,31.53,0,0,1,34.5,66Z"
})));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 69",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.4c3701ba.svg";
export { ForwardRef as ReactComponent };